import axios from 'axios';

axios.defaults.baseURL = '/api';

module.exports = axios;



/** WEBPACK FOOTER **
 ** ./src/constants/axios.prod.js
 **/